/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable linebreak-style */
import React, { useState } from 'react';
import styled from '@emotion/styled';
import Box from '@material-ui/core/Box';
import Rating from '@material-ui/lab/Rating';
import Typography from '@material-ui/core/Typography';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Progress } from 'reactstrap';

const TotalRatings = ({ totalReviews, average, ratings }) => {
    const averageRating = Math.round(average * 10) / 10;

    const fiveStarCount = ratings.filter((item) => {
        return Math.round(item) === 5;
    });

    const fourStarCount = ratings.filter((item) => {
        return Math.round(item) === 4;
    });

    const threeStarCount = ratings.filter((item) => {
        return Math.round(item) === 3;
    });

    const twoStarCount = ratings.filter((item) => {
        return Math.round(item) === 2;
    });

    const oneStarCount = ratings.filter((item) => {
        return Math.round(item) === 1;
    });

    const ratingPercentage = (item) => {
        const count = item.length;
        const percentage = (count / totalReviews) * 100;
        return percentage.toFixed();
    };

    function LinearProgressWithLabel(props) {
        return (
            < Box display="flex" alignItems="center" >
                <Box minWidth={50}>
                    <Typography variant="body2"> {props.rating} </Typography>
                </Box>
                <Box width="100%" mr={1} >
                    <LinearProgress variant="determinate" {...props} />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2">{`${Math.round(
                        props.value,
                    )}%`}</Typography>
                </Box>
            </Box >
        );
    }
    return (
        <RatingsWrapper>
            <RatingsContainer>
                <Box component="fieldset" mb={3} borderColor="transparent">
                    <Rating
                        name="customized-empty"
                        precision={0.5}
                        size="large"
                        emptyIcon={<StarBorderIcon fontSize="inherit" />}
                        readOnly
                        value={averageRating}
                    />
                    <div className="rating-review">
                        <p> <span className="bold-span"> {averageRating} </span> Rating </p>
                        <p style={{ marginLeft: '1rem' }}> <span className="bold-span"> {totalReviews} </span> Review(s) </p>
                    </div>
                </Box>

                <RatingsProgress>
                    <div className="rating-container">
                        <p className="ratings-bar-text">5 star</p>
                        <Progress color="warning" value={ratingPercentage(fiveStarCount)} style={{ width: '75%' }} />
                        <p className="ratings-bar-text"> {ratingPercentage(fiveStarCount)}%</p>
                    </div>

                    <div className="rating-container">
                        <p className="ratings-bar-text"> 4 star </p>
                        <Progress color="warning" value={ratingPercentage(fourStarCount)} style={{ width: '75%' }} />
                        <p className="ratings-bar-text"> {ratingPercentage(fourStarCount)}%</p>
                    </div>

                    <div className="rating-container">
                        <p className="ratings-bar-text"> 3 star </p>
                        <Progress color="warning" value={ratingPercentage(threeStarCount)} style={{ width: '75%' }} />
                        <p className="ratings-bar-text"> {ratingPercentage(threeStarCount)}%</p>
                    </div>

                    <div className="rating-container">
                        <p className="ratings-bar-text"> 2 star </p>
                        <Progress color="warning" value={ratingPercentage(twoStarCount)} style={{ width: '75%' }} />
                        <p className="ratings-bar-text"> {ratingPercentage(twoStarCount)}%</p>
                    </div>

                    <div className="rating-container">
                        <p className="ratings-bar-text"> 1 star </p>
                        <Progress color="warning" value={ratingPercentage(oneStarCount)} style={{ width: '75%' }} />
                        <p className="ratings-bar-text"> {ratingPercentage(oneStarCount)}%</p>
                    </div>
                </RatingsProgress>
            </RatingsContainer>
        </RatingsWrapper>
    );
};

export default TotalRatings;

const RatingsWrapper = styled.div`
`;

const RatingsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    width: 20rem;

    padding-bottom: 4rem;
    border-bottom: 1px solid #D3D9DE;

    .rating-review{
        display: flex;
        flex-direction: row;
        
        margin-top: 0.5rem;
        padding-left: 0.5rem;

        font-size: 16px;
        line-height: 16px;

        color: #525B64;
    }

    .bold-span{
        font-weight: bold;
    }
`;

const RatingsProgress = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    gap: 10px;

    padding-left: 0.5rem;

    .rating-container{
        display: flex;
        flex-direction: row;
        width: 100%;
        gap: 10px;
        /* justify-content: space-evenly; */
    }

    .ratings-bar-text{
        font-size: 12px;
        line-height: 12px;
        color: #000000;
    }
`;
